import axios from 'axios'

const zalogLeasingModule = {
    namespaced: true,
    state: {
        leasing: {
            list: [],
            pagination: null,
            totalActive: null,
            isLoading: true
        },  
        zalog: {
            updateDate: null,
            actual: null,
            totalCount: null,
            isLoading: false,
            isUpdating: false,
            list: [],
            pagination: null
        }
    },
    actions: {
        getLeasingInfo({ dispatch, rootState, commit, state }, { limit, offset }) {
            commit(
                'setStateObject',
                { name: 'card.zalogLeasing.leasing.isLoading', value: true },
                { root: true }
            )

            return dispatch('v3/API', {
                method: 'leasing',
                data: {
                    ogrn: parseInt(rootState.card?.company?.ogrn),
                    limit,
                    offset
                }
            }, { root: true }).then(e => {
                if(e.data?.code === 0 && e.data?.data?.list?.length) {
                    const result = state.leasing.list.concat(e.data?.data?.list || [])

                    commit(
                        'setStateObject', 
                        { name: 'card.zalogLeasing.leasing.list', value: result }, 
                        { root: true }
                    )
                    commit(
                        'setStateObject', 
                        { name: 'card.zalogLeasing.leasing.pagination', value: e.data.data.pagination }, 
                        { root: true }
                    )
                    commit(
                        'setStateObject', 
                        { name: 'card.zalogLeasing.leasing.totalActive', value: e.data.data.activity }, 
                        { root: true }
                    )
                    commit(
                        'setStateObject',
                        { name: 'card.zalogLeasing.leasing.isLoading', value: false },
                        { root: true }
                    )
                }
            }).catch(err => {
                console.error(err.message)
                commit(
                    'setStateObject',
                    { name: 'card.zalogLeasing.leasing.isLoading', value: false },
                    { root: true }
                ) 
            })
        },
        getZalogData({ dispatch, commit, rootState }, { limit, offset }) {

            commit(
                'setStateObject',
                { name: 'card.zalogLeasing.zalog.isLoading', value: true },
                { root: true }
            )

            return dispatch('v3/API', {
                urlMethod: 'zalog_pledge',
                method: 'pledge',
                data: {
                    action: 'list_pledge',
                    ogrn: parseInt(rootState.card?.company?.ogrn),
                    limit,
                    offset
                }
            }, { root: true }).then(e => {
                if(e.status === 200 && e.data?.code === 0) {
                    commit(
                        'setStateObject',
                        { name: 'card.zalogLeasing.zalog.actual', value: e.data?.data?.status },
                        { root: true }
                    )
                    commit(
                        'setStateObject',
                        { name: 'card.zalogLeasing.zalog.updateDate', value: e.data?.data?.actual_date },
                        { root: true }
                    )
                    commit(
                        'setStateObject',
                        { name: 'card.zalogLeasing.zalog.totalCount', value: e.data?.data?.pagination?.rows_count },
                        { root: true }
                    )
                    commit(
                        'setStateObject',
                        { name: 'card.zalogLeasing.zalog.pagination', value: e.data?.data?.pagination },
                        { root: true }
                    )
                    commit(
                        'setStateObject',
                        { name: 'card.zalogLeasing.zalog.list', value: e.data?.data?.list_pledges || []},
                        { root: true }
                    )
                    commit(
                        'setStateObject',
                        { name: 'card.zalogLeasing.zalog.isLoading', value: false },
                        { root: true }
                    )
                    
                } else {
                    commit(
                        'setStateObject',
                        { name: 'card.zalogLeasing.zalog.isLoading', value: false },
                        { root: true }
                    )
                }
            }).catch(err => {
                console.error(err.message)
                commit(
                    'setStateObject',
                    { name: 'card.zalogLeasing.zalog.isLoading', value: false },
                    { root: true }
                )
            })
        },
        updateZalog({ dispatch, commit, rootState }) {

            commit(
                'setStateObject',
                { name: 'card.zalogLeasing.zalog.isUpdating', value: true },
                { root: true } 
            )

            return dispatch('v3/API', {
                urlMethod: 'update_zalog_pledge',
                method: 'pledge',
                data: {
                    action: 'update_pledge',
                    ogrn: parseInt(rootState.card?.company?.ogrn)
                }
            }, { root: true }).then(e => {
                if(e.status === 200 && e.data?.code === 0) {
                    dispatch('getZalogData', { limit: 15, offset: 0 })
                        .finally(() => {
                            commit(
                                'setStateObject',
                                { name: 'card.zalogLeasing.zalog.isUpdating', value: false },
                                { root: true } 
                            )
                        })
                } else {
                    commit(
                        'setStateObject',
                        { name: 'card.zalogLeasing.zalog.isUpdating', value: false },
                        { root: true } 
                    )
                }
            }).catch(err => {
                console.error(err.message)
                commit(
                    'setStateObject',
                    { name: 'card.zalogLeasing.zalog.isUpdating', value: false },
                    { root: true } 
                )
            })
        }
    }
}

export default zalogLeasingModule